module.exports = __webpack_public_path__ + "img/banner-bg.e6024a4a.jpg";